<template>
  <div class="launch-1-day">
    <div class="launch-1-day-info">
      <div class="launch-1-day-left-part">
        <img
          v-motion
          src="/img/launch-main-img-min.png"
          alt=""
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        />
      </div>

      <div class="launch-1-day-right-part">
        <h1>
          Launch your subscriptions <br />
          in 1 day!
        </h1>

        <p>
          Successfully launch your subscriptions with
          <span> HelixPay's Powerful Management Tools. </span>
        </p>

        <a href="https://console.helixpay.ph/#/login">
          <div class="try-btn">
            <p>Try it for free</p>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.launch-1-day {
  width: 100%;
  background-color: #f3f7f8;
}

.launch-1-day-info {
  width: 72rem;
  margin: auto;
  padding-top: 3rem;
  display: flex;
  gap: 2rem;
  align-items: center;
}

.launch-1-day-left-part,
.launch-1-day-right-part {
  width: 100%;
}

.launch-1-day-left-part img {
  width: 90%;
}

.launch-1-day-right-part a {
  text-decoration: none;
}

.launch-1-day-right-part h1 {
  line-height: 1.5;
  font-size: 2rem;
  font-weight: 700;
}

.launch-1-day-right-part p {
  line-height: 2;
  font-weight: 500;
  opacity: 0.6;
}

.launch-1-day-right-part span {
  font-weight: 600;
  color: #25a4e1;
}

.launch-1-day-right-part p:nth-child(even) {
  font-size: 1.2rem;
  margin-top: 1.5rem;
}

.try-btn {
  width: 10rem;
  height: 3rem;
  display: grid;
  align-items: center;
  margin-top: 1rem;
  padding: 0.7rem;
  border-radius: 10px;
  color: white !important;
  opacity: 1 !important;
  background-color: #ff5f8f;
  transition: 0.2s ease-in-out;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.try-btn p {
  text-align: center;
}

.try-btn:hover {
  color: white;
  background-color: #25a4e1;
}

@media only screen and (max-width: 1400px) {
  .launch-1-day-info {
    width: 60rem;
  }

  .five-steps-info {
    width: 60rem;
  }

  .first-3-steps {
    width: 100%;
    margin: auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 2rem;
  }

  .second-2-steps {
    width: 39.7rem;
  }

  .img1 {
    margin: 1rem;
  }

  .img2 {
    padding-bottom: 1rem;
  }

  .img3 {
    padding-bottom: 2rem;
  }

  .img4,
  .img5 {
    padding-bottom: 0.5rem;
  }
}

@media only screen and (max-width: 1050px) {
  .launch-1-day-info {
    width: 40rem;
    display: grid;
    grid-template-columns: 1fr;
  }

  .launch-1-day-left-part img {
    width: 70%;
    display: block;
    margin: auto;
  }

  .launch-1-day-right-part > p {
    width: 60%;
    margin: auto;
  }

  .launch-1-day-right-part,
  .try-btn {
    align-items: center;
    text-align: center;
    margin: auto;
    margin-top: 1rem;
  }
}

@media only screen and (max-width: 650px) {
  .launch-1-day-info {
    width: 90%;
  }

  .launch-1-day-info h1 {
    width: 100%;
    font-size: 1.4rem;
  }

  .launch-1-day-right-part > p {
    width: 80%;
  }
}
</style>
